import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { DepartmentalAutonomyHeroSection } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyHeroSection";
import { DepartmentalAutonomyTakeaway } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyTakeaway";
import { DepartmentalAutonomyFounderQuote } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyFounderQuote";
import { DepartmentalAutonomyProblems } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyProblems";
import { DepartmentalAutonomyPlaybook } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyPlaybook";
import { DepartmentalAutonomyAccountability } from "@/components/insights/departmental-autonomy/DepartmentalAutonomyAccountability";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";


const DepartmentalAutonomy = () => {
  return (
    <>
      <InsightSEO 
        slug="departmental-autonomy" 
        additionalKeywords={["departmental autonomy", "founder interference", "micromanagement", "team ownership", "organizational boundaries", "delegation boundaries", "department accountability"]}
      />
      <InsightEngagementTracker slug="departmental-autonomy" title="Stop Interfering: Departmental Autonomy" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Business IT" 
          currentPage="Departmental Autonomy" 
        />
        <DepartmentalAutonomyHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <DepartmentalAutonomyTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <DepartmentalAutonomyFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <DepartmentalAutonomyProblems />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DepartmentalAutonomyPlaybook />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DepartmentalAutonomyAccountability />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="departmental-autonomy" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="departmental-autonomy" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="departmental-autonomy" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default DepartmentalAutonomy;
